import {IndividualFilterModel} from '@spa/api';

// UI-only control name for the "Onboarding Stage" filter on the Marketing Reports page.
// It has no dedicated backend field: its value is translated into the `statuses` filter
// (a status group), because the "Lead / For Verification / Client" grouping is derived
// from the client status (see EnumsHelper.getStatusGroupName).
export const OnboardingStageSelector = 'onboarding_stage';

export enum OnboardingStagesEnum {
    All = 'all',
    Leads = 'leads',
    ForVerification = 'for_verification',
    Client = 'client'
}

// Maps an onboarding stage to the client statuses that make up that stage.
// Returns null for "All" (meaning: no status-group constraint).
export const getStatusesForOnboardingStage = (stage: string): number[] => {
    switch (stage) {
        case OnboardingStagesEnum.Leads:
            return IndividualFilterModel.getLeadsStatuses();
        case OnboardingStagesEnum.ForVerification:
            return IndividualFilterModel.getVerificationStatuses();
        case OnboardingStagesEnum.Client:
            return IndividualFilterModel.getClientStatuses();
        default:
            return null;
    }
};
